import React, { useEffect, useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { purchaseNotices } from '../data/testimonials';
const INTERVAL_MS = 20000;
const VISIBLE_MS = 5000;
export function PurchaseNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let count = 0;
    let started = false;
    let interval: ReturnType<typeof setInterval> | undefined;
    let first: ReturnType<typeof setTimeout> | undefined;
    let hide: ReturnType<typeof setTimeout> | undefined;
    const showNext = () => {
      setIndex(count % purchaseNotices.length);
      count += 1;
      setVisible(true);
      hide = setTimeout(() => setVisible(false), VISIBLE_MS);
    };
    const onScroll = () => {
      if (started || window.scrollY < window.innerHeight * 0.9) return;
      started = true;
      window.removeEventListener('scroll', onScroll);
      first = setTimeout(showNext, 3000);
      interval = setInterval(showNext, INTERVAL_MS);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', onScroll);
      clearTimeout(first);
      clearTimeout(hide);
      clearInterval(interval);
    };
  }, []);
  const notice = purchaseNotices[index];
  return <div className="fixed left-3 md:left-5 bottom-[112px] md:bottom-[124px] z-50 pointer-events-none" aria-live="polite" data-id="element-186" data-mp="1ngjl5ijza6x8">
      <div className={`flex items-center gap-2.5 bg-ivory border border-sage/50 rounded-xl shadow-soft pl-2.5 pr-4 py-2 transition-[opacity,transform] duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`} data-id="element-187" data-mp="19omxprt98l76">
        <span className="w-6 h-6 rounded-full bg-sage-light text-sage-deep flex items-center justify-center flex-shrink-0" data-id="element-188" data-mp="14qv32q186kza">
          <CheckIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-189" data-mp="qswrtti7b4o0" />
        </span>
        <span className="leading-tight" data-id="element-190" data-mp="vou85ztgsb0s">
          <span className="block font-sans text-sm font-semibold text-terracotta-deep" data-id="element-191" data-mp="2xejd3jre0v3z">
            {notice.name}
          </span>
          <span className="block font-sans text-xs text-forest" data-id="element-192" data-mp="2sn1kbiziq0u3">{notice.location}</span>
        </span>
      </div>
    </div>;
}